import { DataTestId } from '../../ui/layout/DataTestIdWrapper';
import { Flex, FlexProps } from '../../ui/layout/Flex';
import { Typography } from '../../ui/typography/Typography';
import { useTranslation } from '../../utils/useTranslation';

export const SearchNotFound = (props: FlexProps) => {
    const t = useTranslation();

    return (
        <Flex
            px={3}
            alignItems="flex-start"
            justifyContent="center"
            flexGrow={1}
            spacing={1}
            dataTestId={DataTestId.SEARCH_NOT_FOUND}
            {...props}
        >
            <Typography variant="title2" weight="bold">
                {t('Ничего не найдено')}
            </Typography>
            <Typography>
                {t('Попробуйте другой запрос.')}
                <br />
                {t('Например «Кроссовки» или «Путешествия»')}
            </Typography>
        </Flex>
    );
};
